module.exports = __webpack_public_path__ + "img/Fussbad.7b790695.jpg";